import { SortDirection } from "../pages/shared/entities/Sort";
import { DataType } from "./CompanyService";
import RequestPortalService from "./RequestPortalService";

export type PortalClientResponse = {
  personName: string;
  urlLogo: string;
  paymentMethod: string;
  clientInfo: ClientInfoType;
  customerFieldName?: string;
  customersFieldName?: string;
  customerMessages?: boolean;
  customerPortalShowHistory?: boolean;
  groupName?: string;
  showGroup?: boolean;
  referenceNumberName?: string;
  companyName?: string;
  showCents?: boolean;
  allowPaymentProvider?: boolean;
  allowsMultipleInvoices?: boolean;
  customersFieldAmountToPay?: number;
};
export type ClientInfoTypeValue = {
  value: string;
  type: DataType;
};
export type ClientInfoType = {
  Observaciones: ClientInfoTypeValue;
  Domicilio: ClientInfoTypeValue;
  Contacto: ClientInfoTypeValue;
  Teléfono: ClientInfoTypeValue;
  CUIT: ClientInfoTypeValue;
  Categoria: ClientInfoTypeValue;
  Celular: ClientInfoTypeValue;
  Ciudad: ClientInfoTypeValue;
  Fecha: ClientInfoTypeValue;
  BLOQUEADO: ClientInfoTypeValue;
  Hipervínculo: ClientInfoTypeValue;
};

export type PortalIoStatusestResponse = {
  personName: string;
  urlLogo: string;
  paymentMethod: string;
  clientInfo: any;
  customerFieldName?: string;
  customersFieldName?: string;
};

export type PortalClientDataResponse = {
  data: PortalClientResponse;
  itemCount?: number;
  pageSize?: number;
};
export type FieldDataStatus = {
  Dependencies: any[];
  IOStatusID: number;
  Name: string;
};
export type PortalIoStatusesDataResponse = {
  statuses: FieldDataStatus[];
};

export type PortalCustomerTokenResponse = {
  token: string;
};

export type fieldsandvaluesKeyValue = { id: number; value?: string };
export class PortalRequestSaveMessage {
  ids: string;
  iostatusid: number;
  email: string | null = null;
  comment: string | null = null;
  fieldsandvalues: fieldsandvaluesKeyValue[] | [] = [];
  files: string[] | [] = [];

  constructor() {
    this.ids = "";
    this.iostatusid = 0;
    this.files = [];
    this.fieldsandvalues = [];
  }
}

export type TokenByHashRequest = {
  hash: string;
};

export enum PaymentLinkActions {
  NoSupport = 0,
  Redirect = 1,
  RenderHtml = 2
}

export type ProviderCurrency = {
  PaymentLinkProviderCurrencyId: number;
  CompanyId: number;
  PaymentLinkProviderId: number;
  CurrencyID: number;
  ClientSymbol: string;
  Created: string;
  ExchangeRateEnabled: boolean;
};

export type PaymentProvider = {
  PaymentLinkProviderId: number;
  CompanyId: number;
  PaymentProviderId: number;
  PaymentProviderName: string;
  TypeAction: PaymentLinkActions;
  UrlLogo?: string;
  Currencies: ProviderCurrency[];
};

export type PaymentProvidersResponse = {
  list: PaymentProvider[];
};

export type SendPaymentRequest = {
  invoices: number[];
  providerId: number;
  currencyId?: number;
};

export type SendPaymentResponse = {
  payment: {
    PaymentLinkTransactionId: number;
    IsSuccessful: boolean;
    PaymentSatus: number;
    CheckoutLink?: string;
    ExternalId?: string;
    TypeAction: PaymentLinkActions;
    AdditionalData?: string;
  };
};

export type PortalClientIoDataResponse = {
  headers: [
    {
      columnId: string;
      dataType: number;
      columnTitle: string;
    }
  ];
  rowsToShow: [
    {
      Key: string;
      Value: true;
    }
  ];
  count: number;
  page: number;
  pagesize: number;
  totalAmount: number;
  totalPending: number;
  currencyTotals: {
    "(1994, $)": [
      {
        Item1: number;
        Item2: number;
      }
    ];
    "(19037, U$D)": [
      {
        Item1: number;
        Item2: number;
      }
    ];
    "(67586, €)": [
      {
        Item1: number;
        Item2: number;
      }
    ];
  };
};

export class PortalClientDataRequest {
  page: number = 0;
  pagesize: number = 10;
  sortColumn: string = "dueDate";
  descending: SortDirection = SortDirection.Ascending;
  filter: string | null = null;
  quickFilter: number | null = null;
}

class PortalClientService {
  public static getClientData(
    customerToken: string
  ): Promise<PortalClientDataResponse | Error> {
    return RequestPortalService.post("/customer/get", {}, customerToken);
  }
  public static getIoList(
    request: PortalClientDataRequest,
    customerToken: string,
    language: string
  ): Promise<PortalClientIoDataResponse | Error> {
    return RequestPortalService.post(
      "/customer/getiolist",
      { ...request, language },
      customerToken
    );
  }
  public static getAdditionals(
    customerToken: string
  ): Promise<PortalClientDataResponse | Error> {
    return RequestPortalService.post(
      "/customer/getadditionals",
      {},
      customerToken
    );
  }
  public static getIoStatuses(
    customerToken: string
  ): Promise<{ data: PortalIoStatusesDataResponse } | Error> {
    return RequestPortalService.post(
      "/customer/getiostatuses",
      {},
      customerToken
    );
  }
  public static saveMessage(
    data: PortalRequestSaveMessage,
    customerToken: string
  ): Promise<{ data: PortalIoStatusesDataResponse } | Error> {
    return RequestPortalService.post(
      "/customer/SendMessage",
      data,
      customerToken
    );
  }
  public static getTokenByHash(
    data: TokenByHashRequest
  ): Promise<{ data: PortalCustomerTokenResponse } | Error> {
    return RequestPortalService.post("/customer/gettoken", data);
  }
  public static async getDownloadIoFile(
    fileId: string,
    fileName: string = "export.xlsx"
  ) {
    return RequestPortalService.downloadFile(
      "/customer/downloadiofiles?ioID=" + fileId,
      fileName
    );
  }
  public static getPaymentProviders(
    customerToken: string
  ): Promise<PaymentProvidersResponse | Error> {
    return RequestPortalService.get<PaymentProvidersResponse>(
      "/customer/providersbycompany",
      customerToken
    );
  }
  public static sendPayment(
    data: SendPaymentRequest,
    customerToken: string
  ): Promise<SendPaymentResponse | Error> {
    return RequestPortalService.post<SendPaymentResponse>(
      "/customer/sendPayment",
      data,
      customerToken
    );
  }
}

export default PortalClientService;
